import './ui.css';

export function RadioGroup({ name, options = [], value, onChange }) {
  return (
    <div className="ui-grid">
      {options.map((option) => (
        <label className="ui-radio-option" key={`${name}-${option.value}`}>
          <input
            className="ui-radio"
            type="radio"
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={onChange}
          />
          <span>{option.label}</span>
        </label>
      ))}
    </div>
  );
}
